// extracted by mini-css-extract-plugin
export default {"panel":"globalFilters_panel__1+bl4","filters-container":"globalFilters_filters-container__SKmCo","select-container":"globalFilters_select-container__Qj814"};